/**
 * Ensure a JWT exists for arcade manual-run persistence.
 * Reuses stored login/guest session; otherwise creates a guest via enterGuest().
 */

let guestEnsureInFlight = null;

export function readStoredAuth() {
    try {
        const token = localStorage.getItem('token');
        if (!token) return null;
        let user = null;
        try {
            user = JSON.parse(localStorage.getItem('user') || 'null');
        } catch {
            user = null;
        }
        return { token, user };
    } catch {
        return null;
    }
}

/**
 * @param {{ token?: string|null, user?: object|null, enterGuest?: () => Promise<{ok:boolean, token?:string, user?:object}> }} auth
 * @returns {Promise<{token: string, user: object|null}|null>}
 */
export async function ensureArcadeIdentity(auth = {}) {
    const fromArgs = auth.token ? { token: auth.token, user: auth.user || null } : null;
    const stored = fromArgs || readStoredAuth();
    if (stored?.token) return stored;

    if (typeof auth.enterGuest !== 'function') return null;

    if (!guestEnsureInFlight) {
        guestEnsureInFlight = (async () => {
            try {
                const again = readStoredAuth();
                if (again?.token) return again;

                const result = await auth.enterGuest();
                if (result?.ok && result.token) {
                    return { token: result.token, user: result.user || null };
                }
                return readStoredAuth();
            } finally {
                guestEnsureInFlight = null;
            }
        })();
    }
    return guestEnsureInFlight;
}

/** Test helper — clears the in-flight guest latch. */
export function _resetGuestEnsureForTests() {
    guestEnsureInFlight = null;
}
